<!--
  When using this component, make sure there's at least 10px between a badge and any surrounding element.
  By default badges will be displayed horizontally, next to each other.  Use the 'vertical' prop to align them vertically.

  For apple's guidelines see: https://developer.apple.com/app-store/marketing/guidelines/
  For google's guidelines see: https://play.google.com/intl/en_us/badges/
-->

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    vertical?: boolean
  }>(),
  {
    vertical: false
  }
)
</script>

<template>
  <div
    class="tw-inline-flex tw-items-center tw-justify-center tw-gap-2"
    :class="props.vertical ? 'tw-flex-col' : ''"
  >
    <AppStoreButton :image-size-class="props.vertical ? 'tw-w-32' : 'tw-h-10'" />

    <PlayStoreButton :image-size-class="props.vertical ? 'tw-w-32' : 'tw-h-10'" />
  </div>
</template>
